import { EthnicityOptionsType } from './types';

export const ETHNICITY_OPTIONS: EthnicityOptionsType = [
  {
    id: 'african',
    title: 'African',
  },
  {
    id: 'asian',
    title: 'Asian',
  },
  {
    id: 'european',
    title: 'European',
  },
  {
    id: 'latino',
    title: 'Latino',
  },
];
